<template>
    <div class="private-investment _dgrid _grid-cols-12-1 _gap-32-16">
        <div class="_grid-col-span-5-1">
            <slot name="head"></slot>
            <div class="_dflex _flexwrap _mobile-hidden-flx">
                <div
                    v-for="item in tags"
                    :key="item.const"
                    class="private-investment__tag"
                    :class="{
                        'private-investment__tag_active': activeTag === item.const,
                    }"
                    @click="activeTag = item.const"
                    v-html="item.title"
                ></div>
            </div>
            <d-select-search-stable
                :list="tags"
                v-model="activeTag"
                dark
                :searchable="false"
                class="_desktop-hidden"
            />
        </div>
        <transition-group
            class="_grid-col-span-7-1 _dgrid _gap-24-8 _grid-cols-3-2 _position-relative private-investment__light"
            :class="{'_grid-cols-4-1': activeTag === 'Страховые продукты'}"
            tag="div"
            @before-enter="beforeEnter"
            @enter="enter"
            @leave="leave"
            @before-leave="beforeLeave"
            :css="false"
        >
            <div
                v-for="article in visibleArticles"
                :key="article.id"
                :class="{
                    '_desktop-hidden': Array.isArray(article.width) && article.width[0] === 0,
                    '_mobile-hidden': Array.isArray(article.width) && article.width[1] === 0,
                    [Array.isArray(article.width) ? `_grid-col-span-${article.width.join('-')}` : '']: true,
                }"
            >
                <div
                    class="private-investment__tail"
                    :style="{
                        backgroundImage: article.image ? `url(${article.image})` : undefined,
                    }"
                >
                    <div class="p1" v-html="article.title"></div>
                </div>
            </div>
        </transition-group>
    </div>
</template>
<script>
import Velocity from 'velocity-animate';

export default {
    name: 'PrivateInvestment',
    props: {
        /**
         * @type {Article[]}
         * @property {string} Article.id
         * @property {string} Article.title
         * @property {string} Article.image
         * @property {string[]} Article.tags
         * @property {[number, number]} Article.width - [desktop, mobile] from 1 to 3
         */
        articles: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            activeTag: undefined,
        };
    },
    computed: {
        tags() {
            return Array.from(new Set(this.articles.map((item) => item.tags).flat())).map((item) => ({ const: item, title: item }));
        },
        visibleArticles() {
            return this.articles.filter((item) => item.tags.includes(this.activeTag));
        },
    },
    watch: {
        tags: {
            immediate: true,
            handler(val) {
                if (this.activeTag) return;

                this.activeTag = val[0]?.const;
            },
        },
    },
    methods: {
        beforeEnter(el) {
            el.style.opacity = 0;
        },
        beforeLeave(el) {
            el.style.opacity = 1;
        },
        enter(el, done) {
            Velocity(el, { opacity: 1 }, { duration: 300, complete: done });
        },
        leave(el, done) {
            const elRect = el.getBoundingClientRect();
            const parentRect = el.parentElement.getBoundingClientRect();
            el.style.left = `${el.offsetLeft}px`;
            el.style.top = `${el.offsetTop}px`;
            el.style.width = `${elRect.width}px`;
            el.style.height = `${elRect.height}px`;

            if (el.parentElement.dataset.fixed !== '1') {
                el.parentElement.dataset.fixed = '1';
                el.parentElement.style.width = `${parentRect.width}px`;
                el.parentElement.style.height = `${parentRect.height}px`;
            }

            requestAnimationFrame(() => {
                el.style.position = 'absolute';
                if (el.parentElement.dataset.fixed === '1') {
                    el.parentElement.dataset.fixed = '';
                    el.parentElement.style.width = '';
                    el.parentElement.style.height = '';
                }
            });

            Velocity(el, { opacity: 0 }, { duration: 300, complete: done });
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/mixins';
@import '../../assets/scss/base/functions';

.private-investment {
    @include fluid('margin-bottom', 0px, 64px);

    &__tail {
        cursor: default;
        width: 100%;
        display: flex;
        box-sizing: border-box;
        flex-direction: column;
        justify-content: flex-start;
        @include fluid('height', 200px, 160px);
        @include fluid('border-radius', 12px);
        @include fluid('padding', 20px, 16px);
        overflow: hidden;
        background-color: $gray-private;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }

    &__tag {
        cursor: pointer;
        user-select: none;
        flex: none;
        @include p2();
        @include fluid('padding-top', 4px);
        @include fluid('padding-bottom', 4px);
        @include fluid('padding-left', 16px);
        @include fluid('padding-right', 16px);
        background-color: $gray-private;
        @include fluid('border-radius', 8px);
        @include fluid('margin-bottom', 16px);
        @include fluid('margin-right', 16px);
        border: 2px solid transparent;

        &_active {
            border-color: #FFA360;
            background-color: #060707;
        }
    }

    &__light {
        position: relative;

        &::before {
            content: "";
            position: absolute;
            display: block;
            left: 50%;
            top: 50%;
            transform: translate(-20%, -50%);
            @include fluid('width', 424px, 328px);
            @include fluid('height', 424px, 328px);
            border-radius: 9999px;
            filter: blur(20px);
            background: radial-gradient(40% 40%, rgba(241, 117, 2, 0.3) 0%, rgba(255, 188, 139, 0) 100%);
            background-position: 50% 50%;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            animation:
                lightblink 3s ease-in-out infinite alternate,
                lightmove 20s ease-in-out infinite alternate;

            @include mobile {
                display: none;
            }


            @keyframes lightblink {
                0% {
                    background-size: 100% 100%;
                }

                100% {
                    background-size: 50% 50%;
                }
            }

            @keyframes lightmove {
                0% {
                    background-position: 50% 50%;
                }

                25% {
                    background-position: 60% 50%;
                }

                50% {
                    background-position: 50% 60%;
                }

                100% {
                    background-position: 40% 50%;
                }
            }
        }
    }
}
</style>
